import { RouteNames } from 'pages/teach-course/constants';

/**
 * Potential routes of going back/exiting from grading screen
 * Keys are current route, values are appropriate "closed" route
 */
export const exitRoutes = {
  // Entry Point: Grading/Assignments
  [RouteNames.USER_SUBMISSION.assignment_grading_item as string]: RouteNames.ASSIGNMENT_GRADING_ITEM,
  // Entry Point: Quick Grader Beta Button
  [RouteNames.ASSIGNMENT_QUICK_GRADER as string]: RouteNames.ASSIGNMENT_GRADING_ITEM,
  // Entry Point: Learners/Rosters
  [RouteNames.USER_SUBMISSION.rosters_learner_detailed_view_grades as string]:
    RouteNames.LEARNER_DETAILED_VIEW_GRADES.rosters,
};
